import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { cancelCalculationRemove, removeCalculation } from '../../modules/calculation';

import { getUIText } from '../../utils/index';

class CalculationRemoveConfirmDialog extends React.Component {

  state = {
    name: ''
  }

  initName = () => {
    const { project } = this.props;
    const calc = project.calculations[project.calculationIndex] || {};
    this.setState({name: calc.name});
  }

  render() {
    const {
      onCalculationRemove,
      onCancelCalculationRemove,
      app,
      translations,
      open,
    } = this.props;

    return (
      <Dialog
        onClose={onCancelCalculationRemove}
        open={open}
        TransitionProps={{ onEnter: this.initName }}
      >
        <DialogTitle>{getUIText('DIALOG_CALCULATION-REMOVE-DIALOG-TITLE', app.language, translations)} <strong><em>{this.state.name}</em></strong></DialogTitle>
        <DialogContent>
          <DialogContentText>
            {getUIText('DIALOG_CALCULATION-REMOVE-DIALOG-CONTENT-TEXT', app.language, translations)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancelCalculationRemove} color="primary">
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button onClick={onCalculationRemove} color="primary" autoFocus>
            {getUIText('CALCULATION-REMOVE_SECTION', app.language, translations)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

CalculationRemoveConfirmDialog.propTypes = {
    project: PropTypes.object,
    app: PropTypes.object,
    translations: PropTypes.object,
  onCalculationRemove: PropTypes.any,
  onCancelCalculationRemove: PropTypes.any,
  open: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      project: state.project,
      app: state.app,
      translations: state.translations,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCancelCalculationRemove: index => dispatch(cancelCalculationRemove()),
      onCalculationRemove: name => dispatch(removeCalculation()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CalculationRemoveConfirmDialog);
